export default "__VITE_ASSET__C2Wi4ajV__"